import { withInstall } from '@lit-element/utils'

import GitGraph from './src/git-graph.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtGitGraph: SFCWithInstall<typeof GitGraph> = withInstall(GitGraph)
export default LtGitGraph
